import React from "react";

const About = () => {
  return (
    <div className="mt-4 w-full">
      <br />
      <div className="m-4 rounded-lg border border-gray-300 bg-white p-6 shadow-md">
        <p>
          <h1 className="mb-8 justify-center text-center text-2xl font-bold">
            Merci à tous d'avoir participer, photos à venir !
          </h1>
        </p>
        <p>
          <h2 className="mb-4 justify-center text-xl font-bold">
            Programme de la journée :
          </h2>
          <p>
            <b>Date</b> : Jeudi 29 mai 2025 (Ascension) de 10h à 18h
          </p>
          <br />
          <p>
            <b>Lieu</b> : Chalet de l'Ermitage, 23 rue de l'Ermitage, 78000
            Versailles
          </p>
          <p className="mt-1 text-sm">
            <a
              className="text-blue-700 underline"
              href="https://www.ermitage-fondacio.fr/index.html#acces"
              target="_blank"
            >
              Accès en transports en commun et voiture
            </a>

            <br />
          </p>
          <br />
          <p>
            <b>Matin</b>
          </p>
          <ul className="ml-5 list-disc">
            <li>
              À partir de 10h, nous vous accueillons au Chalet de l'Ermitage
              <br />
              Remise des badges & foulards
            </li>

            <li>
              11h : Atelier généalogie pour les enfants de 6 à 12 ans avec la
              Pitoune
            </li>
            <li>12h : Recueillement dans la chapelle de l’Ermitage</li>
          </ul>
          <br />
          <p>
            <b>12h30</b> : Photographie officielle suivie du déjeuner-buffet
            <br />
          </p>
          <br />
          <p>
            <b>Après-midi</b>
          </p>
          <ul className="ml-5 list-disc">
            <li>14h : Discours de Charles de Saxcé</li>
            <li>15h : Quiz en famille sur l'histoire des Saxcé</li>
            <li>18h : Fin de la cousinade</li>
          </ul>
          <br />
          <p>
            <b>Au-delà du Chalet :</b>
          </p>
          <ul className="ml-5 list-disc">
            <li>
              10h30 : Messe en la cathédrale Notre-Dame de Versailles (voir{" "}
              <a
                className="text-blue-700 underline"
                href="https://messes.info/horaires/29%20mai%20versailles"
              >
                messes.info
              </a>
              )
            </li>
            <li>
              Promenade jusqu'à la tombe Saxcé au Cimetière Saint-Louis à
              Versailles
            </li>
          </ul>
          <br />
          <p className="text-justify">
            Pour toute information complémentaire, n'hésitez pas à nous
            contacter à l'adresse <br />
            <a
              className="text-blue-700 underline"
              href="mailto:cousinade@desaxce.com"
            >
              cousinade@desaxce.com
            </a>
          </p>
        </p>
      </div>
    </div>
  );
};

export default About;
